import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { KybRequestProcess } from 'further-types/lp/kyb';
import { kybRequestProcessLabels } from 'further-ui/labels';
import useOnboardingSettings from 'hooks/lp/data/vehicle/useOnboardingSettings';

const schema = z.object({
  kybRequestProcess: z.nativeEnum(KybRequestProcess),
});

type FormValues = z.infer<typeof schema>;

const useKybSettings = (vehicleId: string) => {
  const { onboardingSettings, updateOnboardingSettings } =
    useOnboardingSettings(vehicleId);

  const { control, watch } = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      kybRequestProcess: onboardingSettings.kybRequestProcess,
    },
  });

  const kybRequestProcess = watch('kybRequestProcess');

  const kybRequestProcessOptions = Object.values(KybRequestProcess)
    .filter((process) => process !== KybRequestProcess.ThirdPartyRedirection)
    .map((process) => ({
      label: kybRequestProcessLabels[process],
      value: process,
    }));

  const handleKybRequestProcessChange = (value: KybRequestProcess) => {
    updateOnboardingSettings({
      kybRequestProcess: value,
    });
  };

  return {
    control,
    kybRequestProcess,
    kybRequestProcessOptions,
    handleKybRequestProcessChange,
  };
};

export default useKybSettings;
